// Boss Rooms (맵 데이터) API 서비스
import { supabase } from '../lib/supabase';

export interface BossRoomMap {
  id?: number;
  room_code: string;
  phase: number;
  map_code: string | null;
  metadata: any;
  created_at?: string;
  updated_at?: string;
}

export const bossRoomsApi = {
  // 특정 보스룸의 모든 맵 조회
  getByRoomCode: async (roomCode: string): Promise<BossRoomMap[]> => {
    const { data, error } = await supabase
      .from('boss_rooms')
      .select('*')
      .eq('room_code', roomCode)
      .order('phase', { ascending: true });
    
    if (error) throw error;
    return data || [];
  },

  // 특정 맵 조회
  getById: async (id: number): Promise<BossRoomMap | null> => {
    const { data, error } = await supabase
      .from('boss_rooms')
      .select('*')
      .eq('id', id)
      .single();
    
    if (error && error.code !== 'PGRST116') throw error;
    return data;
  },

  // 맵 생성
  create: async (map: Omit<BossRoomMap, 'id' | 'created_at' | 'updated_at'>): Promise<BossRoomMap> => {
    const { data, error } = await supabase
      .from('boss_rooms')
      .insert(map)
      .select()
      .single();
    
    if (error) throw error;
    return data;
  },

  // 맵 수정
  update: async (id: number, updates: Partial<BossRoomMap>): Promise<BossRoomMap> => {
    const { data, error } = await supabase
      .from('boss_rooms')
      .update(updates)
      .eq('id', id)
      .select()
      .single();
    
    if (error) throw error;
    return data;
  },

  // 맵 삭제
  delete: async (id: number): Promise<void> => {
    const { error } = await supabase
      .from('boss_rooms')
      .delete()
      .eq('id', id);
    
    if (error) throw error;
  }
};